import './order-landing.component.css'
import CallToActionButtonGroup from '../call-to-action-button-group/call-to-action-button-group.component'
import { useEffect, useState } from 'react'
import API from '../../../api'
import { Portal } from 'react-portal'
import { gsap } from 'gsap'
import { cateringIcon, closeIcon, orderIcon, upArrowIcon } from '../../icons'

const OrderLandingComponent = (props) => {
  const { heading, subHeading, restaurantPrompt, locationPrompt } = props
  const [showRestaurants, setShowRestaurants] = useState()
  const [restaurants, setRestaurants] = useState([])
  const [selectedRestaurant, setSelectedRestaurant] = useState()
  const [mode, setMode] = useState()

  useEffect(() => {
    const getRestaurants = async () => {
      try {
        const items = await API.getContent('restaurants')
        const valid = items?.docs.filter(
          (d) => d.defaultLocation && d.cateringOrderingUrl,
        )

        valid.forEach(async (r) => {
          // Fetch logo for each restaurant
          const module = await import(`../../../apps/${r.slug}/icons`)
          if (module.logoIcon) {
            r.logo = module.logoIcon
          }

          // Group locations by state
          const states = {}
          r.locations.forEach((l) => {
            const state = extractState(l.address)
            if (states[state] === undefined) {
              states[state] = []
            }

            states[state].push(l)
          })

          r.states = states
        })

        setRestaurants(valid)
      } catch (e) {
        console.error('Error fetching restaurants: ', e)
      }
    }

    getRestaurants()
  }, [])

  const showModal = (theMode) => {
    setMode(theMode)
    setShowRestaurants(true)

    setTimeout(() => {
      gsap.to('.prg-order-modal', {
        opacity: 1,
        duration: 0.3,
      })

      gsap.to('.prg-order-modal-content', {
        opacity: 1,
        transform: 'translate(-50%, 0)',
        duration: 0.2,
        delay: 0.15,
      })

      scrollTop()
    })
  }

  const scrollTop = () => {
    const el = document.querySelector('.prg-order-modal-content')
    el.scrollTo(0, 0)
  }

  const hideModal = () => {
    gsap.to('.prg-order-modal-content', {
      opacity: 0,
      duration: 0.2,
      transform: 'translate(-50%, 10%) scale(0.9)',
    })

    gsap.to('.prg-order-modal', {
      opacity: 0,
      duration: 0.2,
      delay: 0.1,
      onComplete: () => {
        setTimeout(() => {
          setShowRestaurants(false)
          setSelectedRestaurant(false)
        })
      },
    })
  }

  const extractState = (fullAddress) => {
    if (!fullAddress) return ''
    const parts = fullAddress.split(', ')
    if (parts.length > 1) {
      const stateAndZip = parts[parts.length - 1]
      const state = stateAndZip.split(' ')[0]
      return state
    }
    return ''
  }

  const handleSelectRestaurant = (r) => {
    if (mode === 'catering') {
      window.location.href = r.cateringOrderingUrl
      return
    }

    setSelectedRestaurant(r)
    scrollTop()
  }

  const handleBack = () => {
    setSelectedRestaurant(false)
    scrollTop()
  }

  return (
    <div className="prg-order-landing">
      <div className="prg-order-landing-container">
        <CallToActionButtonGroup heading={heading} subHeading={subHeading} />
        <div className="prg-order-buttons">
          <button
            onClick={() => showModal('pick-up')}
            className="prg-order-main-btn"
          >
            <h2>Pick-Up</h2>
            {orderIcon}
          </button>
          <button
            onClick={() => showModal('catering')}
            className="prg-order-main-btn"
          >
            <h2>Catering</h2>
            {cateringIcon}
          </button>
        </div>
      </div>
      {showRestaurants && (
        <Portal>
          <div className="prg-order-modal" onClick={hideModal}>
            <div
              className="prg-order-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedRestaurant && (
                <button className="prg-order-back-btn" onClick={handleBack}>
                  {upArrowIcon}
                </button>
              )}
              <button className="prg-order-close-btn" onClick={hideModal}>
                {closeIcon}
              </button>
              <div className="prg-order-header">
                <h3>
                  {selectedRestaurant ? locationPrompt : restaurantPrompt}
                </h3>
              </div>
              {selectedRestaurant && (
                <div className="prg-order-logo">{selectedRestaurant.logo}</div>
              )}
              <div
                className={
                  selectedRestaurant
                    ? 'prg-order-locations'
                    : 'prg-order-restaurants'
                }
              >
                {!selectedRestaurant &&
                  restaurants?.map((r) => {
                    return (
                      <div
                        className="prg-order-res"
                        key={r.slug}
                        onClick={() => handleSelectRestaurant(r)}
                      >
                        {r.logo ? (
                          <div className="prg-order-logo-inline">{r.logo}</div>
                        ) : (
                          <h4>{r.name}</h4>
                        )}
                      </div>
                    )
                  })}
                {selectedRestaurant &&
                  Object.keys(selectedRestaurant.states).map((k) => {
                    return (
                      <div className="prg-order-location" key={k}>
                        <h3>{k}</h3>
                        {Object.values(selectedRestaurant.states[k]).map(
                          (e) => {
                            return (
                              <a href={e.orderOnlineUrl} key={e.id}>
                                {upArrowIcon} <span>{e.name}</span>
                              </a>
                            )
                          },
                        )}
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </Portal>
      )}
    </div>
  )
}

export default OrderLandingComponent
